import { render } from "./ListFrame.vue?vue&type=template&id=6184b033&scoped=true"
import script from "./ListFrame.vue?vue&type=script&lang=js"
export * from "./ListFrame.vue?vue&type=script&lang=js"

import "./ListFrame.vue?vue&type=style&index=0&id=6184b033&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-portal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6184b033"]])

export default __exports__